// import axios from "axios";

import axiosClient from "../../../../api/axios";

import { OpenAIMessage } from "../../types/openAI";

import { MessageListResponse } from "../types/openAI";

// const OPENAI_API_KEY = process.env.REACT_APP_OPEN_AI_API_KEY,
//   OPEN_AI_HEADERS = {
//     Authorization: `Bearer ${OPENAI_API_KEY}`,
//     "OpenAI-Beta": "assistants=v2",
//     "Content-Type": "application/json",
//   };

// const axiosClient = axios.create({
//   baseURL: "https://api.openai.com/v1",
//   headers: OPEN_AI_HEADERS,
// });

export const createThread = async () => {
  // Old flow (direct OpenAI route):
  // const response = await axiosClient.post("threads");
  const response = await axiosClient.post("openai/assistants/threads", {});

  return response.data.id;
};

export const runAssistant = async (threadId: string, assistant_id: string) => {
  // Old flow (direct OpenAI route):
  // const response = await axiosClient.post(`threads/${threadId}/runs`, { assistant_id });
  const response = await axiosClient.post(`openai/assistants/threads/${threadId}/runs`, {
    assistant_id,
  });

  return response.data.id;
};

export const sendMessageToThread = async (threadId: string, message: string) => {
  // Old flow (direct OpenAI format):
  // const response = await axiosClient.post(`threads/${threadId}/messages`, {
  //   role: "user",
  //   content: message,
  // });
  const response = await axiosClient.post(`openai/assistants/threads/${threadId}/messages`, {
    message,
  });

  return response.data;
};

export const waitForRunCompletion = async (threadId: string, runId: string) => {
  const terminalStatuses = ["completed", "failed", "cancelled", "expired"] as const;

  while (true) {
    await new Promise((r) => setTimeout(r, 2000));

    // Old flow (direct OpenAI route):
    // const response = await axiosClient.get(`threads/${threadId}/runs/${runId}`);
    const response = await axiosClient.get(`openai/assistants/threads/${threadId}/runs/${runId}`);
    if (response.data.status === "completed") {
      return response.data;
    }

    if (terminalStatuses.includes(response.data.status)) {
      throw new Error(`Run ended with status: ${response.data.status}`);
    }
  }
};

export const fetchLatestMessage = async (threadId: string) => {
  // Old flow (direct OpenAI route):
  // const response = await axiosClient.get<MessageListResponse>(`threads/${threadId}/messages`);
  const response = await axiosClient.get<MessageListResponse>(`openai/assistants/threads/${threadId}/messages`);

  const assistantMessage = response.data.data.find((msg: OpenAIMessage) => msg.role === "assistant");
  if (!assistantMessage) return null;

  return assistantMessage.content[0];
};
